<template>
  <v-dialog v-model="showRoutesDialog" max-width="600">
    <v-card>
      <v-card-title primary-title>
        <h3>Rutas</h3>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="notAssignedRoutes"
          hide-actions
          class="elevation-1"
          item-key="id"
        >
          <template v-slot:items="props">
            <td>{{props.item.real_date | formatDate}}</td>
            <td><router-link :to="routeLink(props.item)">{{props.item.description}}</router-link></td>
            <td>{{props.item.name}}</td>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="closeDialog">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { createRoute, getOpenRoutes, openRoute, closeRoute } from '../../services/route';
export default {
  props: {
    showRoutesDialog: {
      type: Boolean,
      default: false,
    },
    bag: {
      type: Object,
      required: true,
    },
    batches: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: 'Fecha', value: 'created_on'},
        { text: 'Ruta', value: 'description' },
        { text: 'Operador', value: 'name' },
      ],
    };
  },
  computed: {
    notAssignedRoutes() {
      return  _.differenceBy(this.batches, this.bag.routes, 'id');
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close-dialog');
    },
    routeLink(route) {
      return `/bag/${this.bag.id}/route/${route.id}`;
    },
  }
};
</script>